/* angular modules */
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OnlyNumberModule } from '../pages/medical-underwriting/directives/custom-onlyNumber-directive';
/* custom component */
import * as formElementsComponents from '../form-elements';
import { CurrencyModule } from '../shared';
import { CapitalizePipe } from './pipe/capitalize.pipe';

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    CurrencyModule,
    OnlyNumberModule
  ],

  declarations: [
    formElementsComponents.TextInputComponent,
    formElementsComponents.NationalInsuranceNumberComponent,
    formElementsComponents.AccordComponent,
    formElementsComponents.DropdownComponent,
    formElementsComponents.DropdownStandrdComponent,
    formElementsComponents.ButtonComponent,
    formElementsComponents.CheckboxComponent,
    formElementsComponents.RadioButtonComponent,
    formElementsComponents.RadioButtonDotComponent,
    formElementsComponents.PostcodeComponent,
    formElementsComponents.DateInputComponent,
    formElementsComponents.OtherTitleDropdownComponent,
    formElementsComponents.CountryComponent,
    // formElementsComponents.CurrencyComponent,
    formElementsComponents.QuestionRadioButtonComponent,
    formElementsComponents.ToolTipNotificationComponent,
    formElementsComponents.NameTextInputComponent,
    formElementsComponents.TabSquareButtonComponent,
    formElementsComponents.ToggleStandardComponent,
    formElementsComponents.MultipleInputboxComponent,
    formElementsComponents.AccordionQuestionsDirective,
    formElementsComponents.ModalMwComponent,
    formElementsComponents.CapitalizePipe
  ],
  exports: [
    formElementsComponents.TextInputComponent,
    formElementsComponents.NationalInsuranceNumberComponent,
    formElementsComponents.AccordComponent,
    formElementsComponents.DropdownComponent,
    formElementsComponents.DropdownStandrdComponent,
    formElementsComponents.ButtonComponent,
    formElementsComponents.CheckboxComponent,
    formElementsComponents.RadioButtonComponent,
    formElementsComponents.RadioButtonDotComponent,
    formElementsComponents.PostcodeComponent,
    formElementsComponents.DateInputComponent,
    formElementsComponents.OtherTitleDropdownComponent,
    formElementsComponents.CountryComponent,
    // formElementsComponents.CurrencyComponent,
    formElementsComponents.QuestionRadioButtonComponent,
    formElementsComponents.ToolTipNotificationComponent,
    formElementsComponents.NameTextInputComponent,
    formElementsComponents.TabSquareButtonComponent,
    formElementsComponents.ToggleStandardComponent,
    formElementsComponents.MultipleInputboxComponent,
    formElementsComponents.AccordionQuestionsDirective,
    formElementsComponents.ModalMwComponent,
    formElementsComponents.CapitalizePipe
  ]
})
export class FormElementsModule { }
